export const actions = {
    LOGIN_SETCURRENTPAGE: 'LOGIN_SETCURRENTPAGE',
    LOGIN_GETPAGEDATA: 'LOGIN_GETPAGEDATA',
    LOGIN_SETPAGEDATA: 'LOGIN_SETPAGEDATA',
    LOGIN_CLICKLOGINFORM : 'LOGIN_CLICKLOGINFORM',
    LOGIN_RESULTLOGINCLICK : 'LOGIN_RESULTLOGINCLICK',
    LOGIN_LOGOFF: 'LOGIN_LOGOFF',
    ALMS_LOGIN_LOGOUT: 'ALMS_LOGIN_LOGOUT',
    LOGIN_MY_FORGOT_PASSWORD_GET: 'LOGIN_MY_FORGOT_PASSWORD_GET',
    LOGIN_MY_FORGOT_PASSWORD_SET: 'LOGIN_MY_FORGOT_PASSWORD_SET',
    LOGIN_MY_FORGOT_PASSWORD_QUESTION_ANSWER_GET: 'LOGIN_MY_FORGOT_PASSWORD_QUESTION_ANSWER_GET',
    LOGIN_MY_FORGOT_PASSWORD_QUESTION_ANSWER_SET: 'LOGIN_MY_FORGOT_PASSWORD_QUESTION_ANSWER_SET',
    LOGIN_RESET_PASSWORD_CHECK_TOKEN_GET: 'LOGIN_RESET_PASSWORD_CHECK_TOKEN_GET',
    LOGIN_RESET_PASSWORD_CHECK_TOKEN_SET: 'LOGIN_RESET_PASSWORD_CHECK_TOKEN_SET',
    LOGIN_RESET_PASSWORD_SAVE_GET: 'LOGIN_RESET_PASSWORD_SAVE_GET',
    LOGIN_RESET_PASSWORD_SAVE_SET: 'LOGIN_RESET_PASSWORD_SAVE_SET',
    LOGIN_GETUSERIDENTITY : 'LOGIN_GETUSERIDENTITY',
    LOGIN_SETUSERIDENTITY : 'LOGIN_SETUSERIDENTITY',
    LOGIN_EXTERNALLOGIN : 'LOGIN_EXTERNALLOGIN',
    LOGIN_EXTERNALLOGINOBS : 'LOGIN_EXTERNALLOGINOBS',
    LOGIN_EDEVLETLOGIN : 'LOGIN_EDEVLETLOGIN',
    LOGIN_TOALMS : 'LOGIN_TOALMS',
    LOGIN_TOEXAMAPP : 'LOGIN_TOEXAMAPP',
    CHECK_VERIFICATION_CODE : 'CHECK_VERIFICATION_CODE',
    VERIFICATE_USER: "VERIFICATE_USER",
    SET_VERIFICATE_USER_MAIL: "SET_VERIFICATE_USER_MAIL",
    SET_LOGIN_FORM_DATA: "SET_LOGIN_FORM_DATA",
    SET_TWO_FACTOR_CODE_ERROR: "SET_TWO_FACTOR_CODE_ERROR",
    SET_USE_TIMEZONE: 'SET_USE_TIMEZONE',
};
